import { Group } from '@mantine/core';
import type { PolicyViolationOut } from '@repo/api-codegen';
import { Badge, Icon, Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { POLICY_ISSUE_STATUS_MAPPING } from './constants';

interface ViolationStatusBadgeProps {
	violations: PolicyViolationOut[];
}

export const ViolationStatusBadge = observer(
	({ violations }: ViolationStatusBadgeProps) => {
		// Handling the no length case but this shouldn't happen
		if (violations.length === 0) {
			return <Badge variant="success">Passing</Badge>;
		}

		let status = 'open';

		if (violations.some((violation) => violation.resolved_at)) {
			status = 'resolved';
		} else if (violations.some((violation) => violation.ignored_at)) {
			status = 'ignored';
		} else if (violations.some((violation) => violation.acknowledged_at)) {
			status = 'acknowledged';
		}

		return (
			<Group spacing="3xs" noWrap>
				<Icon
					size="md"
					name={POLICY_ISSUE_STATUS_MAPPING[status].iconName}
					fillColor={POLICY_ISSUE_STATUS_MAPPING[status].iconFillColor}
					color={POLICY_ISSUE_STATUS_MAPPING[status].iconColor}
				/>
				<Text size="xs">{POLICY_ISSUE_STATUS_MAPPING[status].name}</Text>
			</Group>
		);
	}
);
